// extracted by mini-css-extract-plugin
export default {"MigrationsTable":"CronLogs_MigrationsTable__6PkmJ"};